// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.modal-xl {\r\n  width: 1440px;\n}\n[dir=ltr] .modal-xl {\r\n  margin-left: auto;\r\n  margin-right: auto;\n}\n[dir=rtl] .modal-xl {\r\n  margin-right: auto;\r\n  margin-left: auto;\n}\r\n", ""]);
// Exports
module.exports = exports;
